import React from 'react';

import { SiteConfigManager } from '@atlas/core';

import { SimplifiedSportsbookProvider } from 'common/SimplifiedSportsbook/SimplifiedSportsbookContext';

const SimplifiedSportsbookViewProvider = ({ children }) => {
  const isSimplifiedView = SiteConfigManager.getConfig(
    'config.config.sportsbook.mobileGridViewType',
  );

  if (isSimplifiedView !== 'simplified') return children;

  return <SimplifiedSportsbookProvider>{children}</SimplifiedSportsbookProvider>;
};

export default SimplifiedSportsbookViewProvider;
